<template>
  <div>
  <div class="d-none d-sm-block">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link to="/">Übersicht</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Anfragen</li>
      </ol>
    </nav>
</div>
    <div v-if="loading" class="d-flex justify-content-center mb-3">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <b-alert v-if="!loading" :show="items.length==0" variant="info">Aktuell keine Anfragen</b-alert>
<div class="table-responsive">
    <b-table v-if="!loading && items.length>0" ref="table" id="item-table" thead-class="d-none" :items="items" :fields="fields" >
    <template #cell(auftragStatus)="data">
      <AuftragOverview ref="AuftragOverview" :auftrag="data.item" @refresh-list="refresh"/>
    </template>
    </b-table>
</div>
    <b-pagination v-if="rows>perPage" v-model="currentPage" :total-rows="rows"
      :per-page="perPage" aria-controls="item-table"></b-pagination>

  </div>
</template>

<script>
import api from '@/api/workflow'
import utils from '@/utilities'
import AuftragOverview from '@/components/partials/AuftragOverview'
import AngebotOverview from '@/components/partials/AngebotOverview'
import afunc from '@/functions'

export default {
  name: 'Anfragen',
  components: {AngebotOverview, AuftragOverview},
  computed: {
    currentPage: {
      get: function () {
        return this.page
      },
      set: async function (newValue) {
        this.page = newValue
        this.offset = (this.page - 1) * this.perPage
        this.refresh()
      }
    },
    rows () {
      return this.pagedList.size
    }
  },
  data () {
    return {
      loading: false,
      items: [],
      pagedList: {},
      fields: ['auftragStatus'],
      perPage: 50,
      page: 1,
      offset: 0,
      msg: ''
    }
  },
  mounted () {
    this.refresh()
  },
  methods: {
    uploadFile (id) {
      afunc.uploadFile(this.$parent, api, id)
    },
    actionFunc (action, id) {
      console.log(this.$parent)
      afunc.actionFunc(this, api, action, id, new FormData())
    },
    statusColor (item) {
      switch (item.auftragStatus) {
        case 'Angelegt':
          return 'bg-light'
      }
    },
    mkTitel (data, mark) {
      return utils.mkTitel(data, mark)
    },
    async update () {
      this.loading = true
      this.pagedList = await api.anfragen(this.offset, this.perPage)
      this.items = this.pagedList.items
      this.loading = false
    },
    async refresh () {
      this.update()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/Anfragen.vue